import React, { forwardRef, isValidElement } from 'react'
import clsx from 'clsx'
import { IconSvg, IconSvgProps } from 'components/common'

export interface InputProps {
	id?: string
	placeholder?: string
	autoComplete?: string
	autoFocus?: boolean
	hasError?: boolean
	onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void
	onInput?: (event: React.FormEvent<HTMLInputElement>) => void
	icon?: React.ReactElement | IconSvgProps
	disabled?: boolean
	className?: string
	type?: string
	defaultValue?: string
	'aria-invalid'?: boolean
	'aria-describedby'?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
	(
		{
			type = 'text',
			placeholder = '',
			autoFocus = false,
			hasError = false,
			onKeyUp = undefined,
			icon = undefined,
			disabled = false,
			className,
			defaultValue,
			onInput,
			...rest
		},
		ref
	) => {
		return (
			<div className="relative w-full">
				<input
					type={type}
					className={clsx(
						'px-4 py-3 border-2 border-translucent-plus-border bg-primary-surface/[0.4] backdrop-blur-lg rounded-lg text-primary-text placeholder-secondary-text placeholder:italic placeholder:font-light block w-full h-12 focus:ring-0 focus:border-translucent-plus-border disabled:text-secondary-text',
						className,
						{
							'!border-secondary-red': !!hasError,
						}
					)}
					disabled={disabled}
					placeholder={placeholder}
					autoFocus={autoFocus}
					aria-invalid={hasError || undefined}
					ref={ref}
					onKeyUp={e => {
						onKeyUp?.(e)
					}}
					{...rest}
					defaultValue={defaultValue}
					onInput={e => {
						onInput?.(e)
					}}
				/>
				{icon && (
					<div className="absolute top-1/2 right-4 -mt-3 h-6 flex flex-col items-center justify-center">
						{isValidElement(icon) ? icon : <IconSvg {...(icon as IconSvgProps)} />}
					</div>
				)}
			</div>
		)
	}
)
